import { Validator } from '@vista-digital/validator';
import { FieldFormatType } from '../../../types/form/field-format-type';
import { emailFieldValidationConfigValidatorSchema, textFieldValidationConfigValidator } from '../../../types/form/field-validation-config';
export const defaultCustomerDetailsFormValidationConfig = {
    email: { type: FieldFormatType.Email, required: true },
    familyName: { type: FieldFormatType.Text, required: true, maxLength: 100 },
    givenName: { type: FieldFormatType.Text, required: true, maxLength: 100 },
    phoneNumber: { type: FieldFormatType.Text, required: true, maxLength: 25 }
};
export const customerDetailsFormValidationConfigValidator = Validator.object({
    email: Validator.object(Object.assign(Object.assign({}, emailFieldValidationConfigValidatorSchema), { required: Validator.isEqualTo(true) })),
    familyName: textFieldValidationConfigValidator,
    givenName: textFieldValidationConfigValidator,
    phoneNumber: textFieldValidationConfigValidator
});
